// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b2110e9a","453":"aeec154d","732":"74261a30"}[chunkId] + ".chunk.js";
};